import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  ({ token }, props: { isFinished?: boolean }) => ({
    card: {
      background: !props?.isFinished
        ? `${token.primary.primary3}1A`
        : token.colorWhite,
      border: `1px solid ${token.colorSplit}`,
      borderRadius: token.borderRadius,
      padding: 16
    },
    text: {
      color: token.colorTextDescription,
      fontSize: 16
    },
    divider: {
      marginInline: 24,
      height: 21,
      borderColor: token.colorSplit
    },
    tag: {
      width: 'fit-content'
    }
  })
)
